import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

export const SidePanel = ({ id, img, title, steps, points, link }) => (
  <aside className="overflow-hidden rounded-3xl border border-gray-200 bg-white lg:sticky lg:top-28" data-testid={`${id}-sidebar`}>
    <img src={img} alt="" className="aspect-[16/9] w-full bg-oath-panel object-cover" />
    <div className="p-6 sm:p-7">
      <h2 className="font-display text-lg font-bold text-oath-ink">{title}</h2>
      <ol className="mt-4 space-y-4">
        {steps.map(([t, d], i) => (
          <li key={t} className="flex gap-3" data-testid={`${id}-side-step-${i + 1}`}>
            <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-oath-accent-light text-xs font-bold text-oath-accent">{i + 1}</span>
            <div><div className="text-sm font-bold text-oath-ink">{t}</div><p className="mt-0.5 text-xs leading-relaxed text-oath-secondary">{d}</p></div>
          </li>
        ))}
      </ol>
      <ul className="mt-6 space-y-2 rounded-2xl bg-oath-mint/60 p-4">
        {points.map((p) => <li key={p} className="flex gap-2 text-xs text-oath-ink"><Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" />{p}</li>)}
      </ul>
      {link && <Link to={link[0]} className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-oath-accent hover:underline" data-testid={`${id}-side-link`}>{link[1]} <ArrowRight className="h-4 w-4" /></Link>}
    </div>
  </aside>
);

export const WithSidePanel = ({ children, panel }) => (
  <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_380px]">
    <div className="min-w-0">{children}</div>
    <SidePanel {...panel} />
  </div>
);
